export default __webpack_public_path__ + "static/media/13AW2FEB66.849adf2b.jpg";